import { lazy } from "react";
import type { Modul } from "../../kern/modul";
import { ZuVeranstaltung, ZuVeranstaltungen } from "./Weiterleitung";

// Erst laden, wenn jemand die Redaktion öffnet (BAUPLAN-PAKETE.md, Abschnitt 5.7)
const Newsletter = lazy(() => import("./Newsletter").then((m) => ({ default: m.Newsletter })));
const Ausgabe = lazy(() => import("./Ausgabe").then((m) => ({ default: m.Ausgabe })));
const Termine = lazy(() => import("./Termine").then((m) => ({ default: m.Termine })));
const Termin = lazy(() => import("./Termin").then((m) => ({ default: m.Termin })));
const Partner = lazy(() => import("./Inhalte").then((m) => ({ default: m.Partner })));
const Vorstand = lazy(() => import("./Inhalte").then((m) => ({ default: m.Vorstand })));
const Mission = lazy(() => import("./Inhalte").then((m) => ({ default: m.Mission })));

/** Redaktion (Phase 5, ADR-004): Newsletter und Website in der App. Daten und Versand bleiben bei der Website (/api/redaktion über den Proxy).
 *  Seit Paket B1 steht jede Seite einzeln unter „Redaktion“. Website-Termine heißen Veranstaltungen, die alten Adressen leiten weiter. */
export const redaktion: Modul = {
  id: "redaktion",
  name: "Redaktion",
  routen: [
    { pfad: "/redaktion/newsletter", seite: Newsletter, recht: "redaktion.newsletter" },
    { pfad: "/redaktion/newsletter/:id", seite: Ausgabe, recht: "redaktion.newsletter" },
    { pfad: "/redaktion/veranstaltungen", seite: Termine, recht: "redaktion.website" },
    { pfad: "/redaktion/veranstaltungen/:slug", seite: Termin, recht: "redaktion.website" },
    { pfad: "/redaktion/website", seite: ZuVeranstaltungen, recht: "redaktion.website" },
    { pfad: "/redaktion/website/termine/:slug", seite: ZuVeranstaltung, recht: "redaktion.website" },
    { pfad: "/redaktion/website/partner", seite: Partner, recht: "redaktion.website" },
    { pfad: "/redaktion/website/vorstand", seite: Vorstand, recht: "redaktion.website" },
    { pfad: "/redaktion/website/mission", seite: Mission, recht: "redaktion.website" },
  ],
  navigation: [
    { bereich: "redaktion", label: "Newsletter", pfad: "/redaktion/newsletter", icon: "newsletter", recht: "redaktion.newsletter", reihenfolge: 10 },
    { bereich: "redaktion", label: "Veranstaltungen", pfad: "/redaktion/veranstaltungen", icon: "veranstaltung", recht: "redaktion.website", reihenfolge: 20 },
    { bereich: "redaktion", label: "Partner", pfad: "/redaktion/website/partner", icon: "partner", recht: "redaktion.website", reihenfolge: 30 },
    { bereich: "redaktion", label: "Vorstandsseite", pfad: "/redaktion/website/vorstand", icon: "vorstandsseite", recht: "redaktion.website", reihenfolge: 40 },
    { bereich: "redaktion", label: "Mission 100", pfad: "/redaktion/website/mission", icon: "mission", recht: "redaktion.website", reihenfolge: 50 },
  ],
  ereignisse: [],
};
